import React, { useMemo, useCallback } from "react";
import cn from "classnames";

import { getFormattedUserName } from "helpers/chats";

import ChatMenuButton from "components/common/ChatMenuButton";
import { DIRECTION } from "components/common/ChatMenu";

import styles from "./styles.module.scss";

export default function ChatContactsItem({
    contact,
    onChatClick,
    openedEmploeeId,
    handleChatWindowClose,
}) {
    const { employee } = contact;
    const userName = useMemo(() => getFormattedUserName(employee), [employee]);
    const handleChatClick = useCallback(() => {
        onChatClick({
            employee,
        });
    }, [onChatClick, employee]);

    return (
        <div className={cn(styles.item, openedEmploeeId === employee.id && styles["item--opened"])}>
            <button className={styles.item__wrapper} onClick={handleChatClick}>
                {employee.picture ? (
                    <img
                        className={styles.item__image}
                        src={employee.picture || ""}
                        alt=""
                    />
                ) : (
                    <span className={styles.item__image} />
                )}
                <div className={styles.item__info}>
                    <p className={styles.item__title}>{employee.company.name}</p>
                    <p className={styles.item__name}>{userName}</p>
                </div>
            </button>
            <ChatMenuButton
                contact={contact}
                direction={DIRECTION.LEFT_BOTTOM}
                handleChatWindowClose={handleChatWindowClose}
                usePortal
            />
        </div>
    );
}
